var React = require('react');

function Frame (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("polygon",{"points":"34,92.5 33,92.5 33,1 0,1 0,0 34,0 \t"})));
}

Frame.defaultProps = {"version":"1.1","id":"Шар_1","viewBox":"0 0 34 92.5","style":{"enableBackground":"new 0 0 34 92.5"}};

module.exports = Frame;

Frame.default = Frame;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/frame.svg
// module id = 1025
// module chunks = 0